module.exports = __webpack_public_path__ + "img/hongbao_img01.4e699756.png";